import React from 'react'
import { Dialog, Form, color, withNotifier } from 'stylist'
import UpdateClipFeedbackTextMutation from 'mutations/UpdateClipFeedbackText'
import styled, { css } from 'react-emotion'
import { object, string } from 'yup'

const StyledDialog = styled(Dialog)`
  color: ${color('slate')};
`

const schema = object().shape({
  text: string().required('Feedback cannot be blank')
})

const ClipFeedbackTextDialog = ({ hide, notify, clipId }) => (
  <UpdateClipFeedbackTextMutation clipId={clipId}>
    {updateClipFeedbackText => (
      <StyledDialog>
        <Dialog.Header onClose={hide}>
          <Dialog.Title>
            Help us train our robots to create more valuable clips for you
          </Dialog.Title>
        </Dialog.Header>
        <Form
          onSubmit={({ text }) =>
            updateClipFeedbackText(text)
              .then(() => notify('success', 'Thanks for your feedback!'))
              .then(hide)
          }
          validationSchema={schema}
        >
          <Dialog.Body>
            <p>
              Could you give us some quick feedback as to why you chose thumbs
              down?
            </p>
            <Form.Group>
              <Form.Textarea
                className={css`
                  resize: vertical;
                `}
                name="text"
              />
            </Form.Group>
          </Dialog.Body>
          <Dialog.Footer>
            <Form.Group buttons>
              <Form.SubmitButton>Submit</Form.SubmitButton>
            </Form.Group>
          </Dialog.Footer>
        </Form>
      </StyledDialog>
    )}
  </UpdateClipFeedbackTextMutation>
)

export default withNotifier(ClipFeedbackTextDialog)



// WEBPACK FOOTER //
// ./src/routes/video/components/ClipFeedbackTextDialog.js